import { BaseRoutes } from './base.routes.constants';

export class PlanoRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
